import { fade, Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default ({ spacing, transitions, breakpoints }: Theme) =>
  createStyles({
    root: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      flexGrow: 1,
      zIndex: 1201,
    },
    menuItem: {
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: 12,

      '& small': {
        display: 'flex',
        alignItems: 'flex-start',
        fontSize: 12,
        opacity: 0.9,
      },
      '& > svg': {
        fontSize: 17,
      },
    },
    notFoundNotification: {
      margin: '12px 0',
    },
    imageNotFound: {
      width: 212,
    },
    logoLink: {
      display: 'flex',
      alignItems: 'center',
    },
    linksExternal: {
      textDecoration: 'none',
      color: 'currentcolor',
    },
    group: {
      display: 'flex',
      flexGrow: 1,
      alignItems: 'center',
    },
    menuButton: {
      marginRight: spacing(1),
      padding: 7,
      color: palette.lightNavSuperAdminActions,
    },
    menuButtonMobile: {
      marginRight: spacing(0),
      padding: 7,
    },
    menuButtonSuperAdmin: {
      marginRight: spacing(1),
      padding: 7,
      color: palette.lightNavSuperAdminActions,
    },
    menuButtonSuperAdminMobile: {
      marginRight: spacing(0),
      padding: 7,
      color: palette.lightNavSuperAdminActions,
    },
    iconFormat: {
      color: palette.deepBlue,
    },
    logo: {
      width: 150,
      marginRight: spacing(2.5),
    },
    logoMobile: {
      marginRight: spacing(1.5),
    },

    buttonSelect: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.grey800,
      marginRight: spacing(2),
      border: `1px solid ${palette.grey200}`,
      padding: '3px 6px 3px 8px',
      boxShadow: `0px 1px 4px ${palette.grey200}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
      '& small': {
        position: 'absolute',
        top: 0,
        left: 8,
        fontSize: 9,
        padding: '0px 6px',
        background: palette.lightNavSuperAdminActions,
        transform: 'translateY(-50%)',
        borderRadius: 10,
        color: palette.grey800,
        zIndex: 1,
      },
    },
    buttonSelectPartner: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.grey200,
      marginRight: spacing(2),
      border: `1px solid ${palette.grey200}`,
      padding: '3px 6px 3px 8px',
      boxShadow: `0px 1px 4px ${palette.grey200}`,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '& small': {
        position: 'absolute',
        top: 0,
        left: 8,
        fontSize: 9,
        padding: '0px 6px',
        background: palette.lightNavSuperAdminActions,
        transform: 'translateY(-50%)',
        borderRadius: 10,
        color: palette.grey800,
        zIndex: 1,
      },
    },

    buttonSelectSuperAdmin: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.lightNavSuperAdminActions,
      marginRight: spacing(2),
      border: '1px solid',
      padding: '3px 4px 0px 7px',

      '& small': {
        position: 'absolute',
        top: 0,
        left: 8,
        fontSize: 9,
        padding: '0px 6px',
        background: palette.lightNavSuperAdminActions,
        transform: 'translateY(-50%)',
        borderRadius: 10,
        color: palette.darkGray,
        zIndex: 1,
        fontWeight: 500,
      },
    },
    topBarTexts: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.darkGray,
    },
    topBarTextsSuperAdmin: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.lightNavSuperAdminActions,
    },
    topBarRole: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.grey800,
    },
    topBarRoleMobile: {
      fontSize: 9,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.grey800,
    },
    topBarRoleSuperAdmin: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.navSuperAdmin,
    },
    topBarRoleSuperAdminMobile: {
      fontSize: 9,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      color: palette.navSuperAdmin,
    },
    buttonSelectAdmin: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navAdmin,
      marginRight: spacing(2),
      border: `1px solid ${palette.navAdmin}`,
      padding: '3px 6px 3px 8px',
      boxShadow: `0px 1px 4px ${palette.navAdmin}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
      '& small': {
        position: 'absolute',
        top: 0,
        left: 8,
        fontSize: 9,
        padding: '0px 6px',
        background: palette.lightNavSuperAdminActions,
        transform: 'translateY(-50%)',
        borderRadius: 10,
        color: palette.grey800,
        zIndex: 1,
      },
    },
    buttonSelectOperator: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navOperator,
      marginRight: spacing(2),
      border: `1px solid ${palette.navOperator}`,
      padding: '3px 6px 3px 8px',
      boxShadow: `0px 1px 4px ${palette.navOperator}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
      '& small': {
        position: 'absolute',
        top: 0,
        left: 8,
        fontSize: 9,
        padding: '0px 6px',
        background: palette.lightNavSuperAdminActions,
        transform: 'translateY(-50%)',
        borderRadius: 10,
        color: palette.grey800,
        zIndex: 1,
      },
    },
    buttonIcon: {
      width: 12,
    },
    expandIcon: {
      width: 17,
      height: 23,
    },
    avatar: {
      width: 23,
      height: 23,
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.deepBlue,
    },
    avatarSuperAdmin: {
      width: 23,
      height: 23,
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdminActions,
    },
    avatarAdmin: {
      width: 23,
      height: 23,
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navAdmin,
    },
    avatarOperator: {
      width: 23,
      height: 23,
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navOperator,
    },

    buttonRegion: {
      color: palette.darkGray,
      borderRadius: 100,

      '& svg': {
        marginRight: 4,
      },
    },

    search: {
      position: 'relative',
      height: 34,
      borderRadius: 6,
      width: 0,
      transition: transitions.create('width'),
    },
    searchFocused: {
      background: fade(palette.white, 1),
      width: 276,
    },
    hiddenLogo: {
      visibility: 'hidden',
    },
    searchInputRoot: {
      width: '100%',
    },
    searchInput: {
      width: '100%',
      padding: '9px 48px 9px 10px',
      fontSize: 14,
    },
    searchIcon: {
      position: 'absolute',
      top: '50%',
      right: 0,
      transform: 'translateY(-50%)',
    },
    navbar: {
      minHeight: 50,
      paddingLeft: 24,
      paddingRight: 17,
      [breakpoints.down('md')]: {
        paddingRight: 0,
      },
      '& .MuiButton-root.Mui-disabled': {
        color: palette.lightNavSuperAdminActions,
        opacity: 0.8,
      },
    },
    menuButtonIcon: {
      width: 19,
      height: 19,
    },
    notificationIcon: {
      fontSize: 5,
    },
    notificationButton: {
      display: 'none',
      padding: 0,
    },
    supportButton: {
      display: 'none',
      padding: 0,
    },
    supportIcon: {
      fontSize: 6,
    },
    profileButton: {
      padding: 1,
      height: 2,
      marginRight: 15,

      '& .MuiIconButton-label': { justifyContent: 'center' },
    },
    profileSelector: {
      marginRight: 10,
      display: 'flex',
      alignItems: 'center',
      [breakpoints.down('md')]: {
        marginRight: 20,
      },
    },
    buttonAdminSelect: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navAdmin,
      marginRight: spacing(2),
      border: `1px solid ${palette.navAdmin}`,
      padding: '3px 6px 3px 8px',
      boxShadow: `0px 1px 4px ${palette.navAdmin}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
    },
    buttonOperatorSelect: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navOperator,
      marginRight: spacing(2),
      border: `1px solid ${palette.navOperator}`,
      padding: '3px 6px 3px 8px',
      boxShadow: `0px 1px 4px ${palette.navOperator}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
    },
    buttonAdminSelectMobile: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navAdmin,
      marginRight: spacing(2),
      border: `1px solid ${palette.navAdmin}`,
      padding: '0px 4px 0px 5px',
      boxShadow: `0px 2px 4px ${palette.navAdmin}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
    },
    buttonSelectMobile: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.grey800,
      marginRight: spacing(2),
      border: `1px solid ${palette.grey200}`,
      padding: '0px 4px 0px 5px',
      boxShadow: `0px 2px 4px ${palette.grey200}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
    },
    buttonOperatorSelectMobile: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navOperator,
      marginRight: spacing(2),
      border: `1px solid ${palette.navOperator}`,
      padding: '0px 4px 0px 5px',
      boxShadow: `0px 2px 4px ${palette.navOperator}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
    },

    buttonSuperAdminSelect: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.navSuperAdminActions,
      marginRight: spacing(2),
      border: '1px solid #e4e5f5',
      padding: '3px 6px 3px 8px',
      boxShadow: '0px 2px 4px',
      backgroundColor: palette.lightNavSuperAdminActions,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.lightNavSuperAdminActions },
    },
    buttonSuperAdminSelectMobile: {
      fontSize: 12,
      fontWeight: 'normal',
      color: palette.deepBlue,
      marginRight: spacing(2),
      border: `1px solid ${palette.deepBlue}`,
      padding: '0px 4px 0px 5px',
      boxShadow: `0px 2px 4px ${palette.deepBlue}`,
      backgroundColor: palette.grey200,

      '& .MuiButton-startIcon': {
        marginRight: 4,
      },

      '&:hover': { backgroundColor: palette.grey200 },
    },
    userView: {
      backgroundColor: palette.primary.main,
    },
    superAdminView: {
      backgroundColor: palette.navSuperAdmin,
    },
    adminView: {
      backgroundColor: palette.grey800,
    },
    operatorView: {
      backgroundColor: palette.grey800,
    },
    grayHeader: {
      color: palette.navSuperAdmin,
    },
    greenHeader: {
      color: palette.navAdmin,
    },
    blueHeader: {
      color: palette.navOperator,
    },
    logoutMessage: { fontSize: 12 },
    profileName: {
      fontSize: 12,
      color: palette.darkGray,
      fontWeight: 500,
      margin: '0px 2px 0px 10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 1,
    },
    profileNameSuperAdmin: {
      fontSize: 12,
      color: palette.lightNavSuperAdminActions,
      fontWeight: 500,
      margin: '0px 2px 0px 10px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: 1,
    },
    dropDownIcon: { color: palette.lightNavSuperAdminActions },
    dropDownIconSuperAdmin: { color: palette.lightNavSuperAdminActions },
    smallText: { fontSize: 9 },
    menuSelectText: {
      color: palette.navCompanyContextActions,
      fontWeight: 'bold',
      fontSize: 12,
    },
    menuSelectIcon: { color: palette.navCompanyContextActions },
    menuSelectTextSuperAdminView: {
      color: palette.navSuperAdminActions,
      fontWeight: 'bold',
      fontSize: 12,
    },
    menuSelectTextAdminView: {
      color: palette.navAdminActions,
      fontWeight: 'bold',
      fontSize: 12,
    },
    menuSelectTextOperatorView: {
      color: palette.navOperatorActions,
      fontWeight: 'bold',
      fontSize: 12,
    },
    menuSelectIconSuperAdminView: { color: palette.navSuperAdminActions },
    menuSelectIconAdminView: { color: palette.navAdminActions },
    menuSelectIconOperatorView: { color: palette.navOperatorActions },
  });
